import { Box } from "@mui/material";
import { Button, Grid, styled, TextField, Typography } from "@mui/material";

export const Title = styled(Typography)({
  marginBottom: "30px",
  color: "#4EAF50",
  fontFamily: "Roboto",
  fontSize: "30px",
  fontWeight: "500",
  lineHeight: "35px",
  letterSpacing: "0em",
  textAlign: "center",
});
export const QuantityBox = styled(Box)({
  width: "90px",
  height: "30px",
  background: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  boxShadow: " 0px 0px 16px 0px #00000029",
  justifyContent: "center",
});
export const Row = styled(Box)({
  height: "60px",
  left: "324px",
  top: "145px",
  borderRadius: "4px",
  background: "#FFFFFF",
  boxShadow: "0px 0px 60px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  padding: "20px",
  display: "grid",
  marginTop: "5px",
  gridTemplateColumns: "10%  50% 40%",
  alignItems: "center",
});
export const RackHead = styled(Box)({
  height: "60px",
  left: "324px",
  top: "145px",
  borderRadius: "4px",
  background: "#4EAF8C",
  boxShadow: "0px 0px 60px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  display: "grid",
  gridTemplateColumns: "98% 2%",
  alignItems: "center",
  margin: "10px 0px",
});

export const RackBox = styled(Grid)({
  position: "relative",
  background: "white",
  padding: "2px 10px",
  marginTop: "5px",
  height: "90px",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "7px",
  display: "flex",
  alignItems: "center",
});

export const ButtonEdit = styled(Button)({
  height: "40px",
  border: "solid 1px #4EAF51",
  color: "#4EAF51",
  textTransform: "none",
  display: "flex",
  justifyContent: "space-evenly",
});
export const ButtonDetail = styled(Button)({
  height: "40px",
  border: "solid 1px #406A80",
  color: "#406A80",
  textTransform: "none",
  display: "flex",
  justifyContent: "space-evenly",
});
export const ButtonDelete = styled(Button)({
  height: "40px",
  color: "#DC5252",
  border: "solid 1px #DC5252",
  textTransform: "none",
  display: "flex",
  justifyContent: "space-evenly",
});

export const DialogInput = styled(TextField)({
  borderRadius: "4px",
  fontSize: "12px",
  marginTop: "5px",
  marginBottom: "5px",
  height: "60px",
});
